<template lang="pug">
el-dialog(title="修改杠杆倍数" :visible.sync="show")
  el-form(:model="form" inline class="form")
    el-form-item(label="杠杆倍数" prop="leverage")
      .slider-wrapper
        el-slider(v-model="form.leverage" show-input :step="0.01")
  div(slot="footer" class="dialog-footer")
    el-button(@click="show = false") 取 消
    el-button(@click="submit") 确 定

</template>

<script>
import { setLeverage } from 'api/futures';

export default {
  components: {},
  data() {
    return {
      show: false,
      form: { leverage: 0 },
      quote: undefined,
    };
  },
  computed: {},
  methods: {
    async open(model, leverage) {
      this.show = true;
      this.quote = model;
      this.form.leverage = leverage;
    },
    async submit() {
      const res = await setLeverage({
        leverage: this.form.leverage,
        currency: this.quote.currency,
        instrumentId: this.quote.instrumentId,
      }).catch((ex) => this.$message.error(ex.message || '设置杠杆发生错误'));
      if (res.code === 0) {
        this.$message.success('设置杠杆成功');
        this.show = false;
        this.$emit('change', this.form.leverage);
      } else {
        this.$message.error(res.msg || '设置杠杆失败');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.form {
  text-align: center;
}
.slider-wrapper {
  width: 450px;
}
</style>
